import React, { Component } from 'react';

import s from './Divider.css';

export default class Divider extends Component {
  render() {
    return <div className={s.divider} />;
  }
}
